import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import '../../containers/customers/customer/CustomerOverviewDetail.scss';
import CustomMultipleSelect from '../base/CustomMultipleSelect';
import { Image } from 'react-bootstrap';
import addOn from '../../assets/images/addOn.svg';
import addOff from '../../assets/images/addOff.svg';
import removeOn from '../../assets/images/removeOn.svg';
import removeOff from '../../assets/images/removeOff.svg';
import { CustomTitleLabel } from '../earning/CustomBaseComponments';
import ErrorFieldMessage from '../base/ErrorFieldMessage';
import { createAction, useCompare } from '../../utils';
import './CustomAddRemoveMutipleSelector.scss';
import AuthButton from '../base/AuthButton';
import { useDispatch } from 'react-redux';
import { withResizeDetector } from 'react-resize-detector';
import { defaultStep } from '../../models/StepBarUtil';

const options = (source) => {
  if (!source) {
    return [];
  }
  return source.map((item) => {
    return {
      name: item.name,
      value: item.value,
    };
  });
};

function CustomAddRemoveMutipleSelector({
  width,
  title,
  titleTips = "",
  data = [],
  selectedList = [],
  orderSelectedListFunction = () => {},
  addButton,
  setValue,
  sourceReminderText,
  amidReminderText,
  error = {},
  isSourceReminderFilterable = false,
  isSourceReminderLocalFilterable = false,
  isAmidRreminderFilterable = false,
  isAmidRreminderLocalFilterable = false,
  sourceReminderEnabelSelectAll = false,
  sourceReminderSubfilterKey,
  aimdReminderSubfilterKey,
  sourceReminderSubFilterItems = [],
  aimdReminderSubFilterItems = [],
  selectAllTitle,
  requires,
  onFocusFunc = () => {},
  loadMoreAction,
  filterPlaceHolder,
  isCustomerItem,
  filterAction,
  isReset = false,
  defaultFilter = {},
  groupKey,
  disabled,
}) {
  let hasMultiLines = false;
  if (width < 707) {
    hasMultiLines = true;
  }
  const history = useHistory();
  const dispatch = useDispatch();

  const getFilteredList = (operatedList, filteredList) => {
    return operatedList?.filter((val) => {
      if (val.value) {
        if (val.value.pk)
          return (
            filteredList?.filter((item) => item.value.pk === val.value.pk)
              .length === 0
          );
        return (
          filteredList?.filter((item) => item.value === val.value).length <= 0
        );
      } else {
        // return !filteredList?.includes(val);
        return (
          filteredList.length <= 0 ||
          filteredList.filter((item) => {
            // console.log('@@======@@:', item.pk, val.pk, item.pk !== val.pk);
            return item.pk !== val.pk;
          }).length === filteredList.length
        );
      }
    });
  };

  const getOrderSelectedList = (originalList = []) => {
    return originalList.sort(orderSelectedListFunction);
  }

  const [amid, setAmid] = useState(getOrderSelectedList(selectedList || []));
  const [sourceSelected, setSourceSelected] = useState();
  const [selected, setSelected] = useState();
  const [removeResetSelected, setRemoveResetSelected] = useState(false);
  const [addResetSelected, setAddResetSelected] = useState(false);
  const [source, setSource] = useState(getFilteredList(data, selectedList));

  const add = () => {
    if (!sourceSelected?.length) {
      return;
    }
    const nextSource = source.filter((val) => !sourceSelected?.includes(val));
    setSource(nextSource);
    if (nextSource?.length <= 0) {
      loadMore();
    };
    setAmid(getOrderSelectedList([...amid, ...sourceSelected]));
    setSourceSelected([]);
    setAddResetSelected(true);
  };

  const remove = () => {
    if (!selected?.length) {
      return;
    }
    setAmid(getOrderSelectedList(getFilteredList(amid, selected)));
    setSource([...getFilteredList(source, selected), ...selected]);
    setSelected([]);
    setRemoveResetSelected(true);
  };

  useEffect(() => {
    console.log('@@116');
    loadMore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isReset) {
      setSource(getFilteredList(data, selectedList));
      setAmid(getOrderSelectedList(selectedList));
      setAddResetSelected(true);
      setRemoveResetSelected(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReset]);

  const defaultFilterChanged = useCompare(defaultFilter);
  useEffect(() => {
    if (defaultFilterChanged) {
      setCurrentPage(0);
    }
  }, [defaultFilter]);

  const dataChanged = useCompare(data);
  const selectedListChanged = useCompare(selectedList);
  useEffect(() => {
    if (dataChanged || (selectedListChanged && !dataChanged)) {
      const newSource = getFilteredList(data, selectedList);
      setSource(newSource);
    }
    if (selectedListChanged) {
      setAmid(getOrderSelectedList(selectedList));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, dataChanged, selectedListChanged, selectedList]);

  const amidValueHasChanged = useCompare(amid);
  useEffect(() => {
    if (amidValueHasChanged) {
      setValue(amid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amid, setValue, amidValueHasChanged]);

  const [currentPage, setCurrentPage] = useState(0);
  const [filterKey, setFilterKey] = useState('');
  const [moreFilter, setMoreFilter] = useState('');

  const loadMore = () => {
    console.log('@@164: ', loadMoreAction);
    if (!loadMoreAction) {
      return;
    }

    const nextPage = currentPage + 1;
    console.log('@@55: ', nextPage, filterKey);
    dispatch(
      createAction(loadMoreAction)({
        page: nextPage,
        search: filterKey,
        searchKey: filterKey,
        isSelectorLoad: true,
        moreSearch: moreFilter,
        ...defaultFilter,
      }),
    );

    setCurrentPage(nextPage);
  };

  const filter = (search, moreSearch) => {
    if (!filterAction) {
      return;
    }

    let nextPage = currentPage + 1;
    if (search !== filterKey) {
      nextPage = 1;
    }

    if (moreSearch !== moreFilter) {
      nextPage = 1;
    }
    // console.log('@@55: ', search, nextPage);
    dispatch(
      createAction(filterAction)({
        page: nextPage,
        search: search,
        searchKey: search,
        isSelectorLoad: true,
        reverse: true,
        moreSearch: moreSearch,
      }),
    );

    setCurrentPage(nextPage);
    setFilterKey(search);
    setMoreFilter(moreSearch);
  };

  return (
    <div className={`d-flex flex-column ${disabled ? 'disabled-opacity' : ''}`}>
      {title ? <CustomTitleLabel title={title} /> : null}
      {titleTips ? <label className="tips-message" style={{marginBottom: "14px"}}>{titleTips}</label> : null}
      <div className="custom-add-remove-mutiple-selector">
        <div
          className="d-flex flex-column"
          style={width < 330 ? { width } : { width: 330 }}
        >
          <CustomMultipleSelect
            isFilterable={isSourceReminderLocalFilterable || isSourceReminderFilterable}
            enableSelectAll={sourceReminderEnabelSelectAll}
            subFilterKey={sourceReminderSubfilterKey}
            subFilterItems={sourceReminderSubFilterItems}
            defaultSelected={[]}
            options={source}
            selectAllTitle={selectAllTitle}
            onSelectChange={(options) => {
              //   setSelectStores(options);
              setAddResetSelected(false);
              setSourceSelected(options);

              onFocusFunc();
              // console.log('@@69: ', options);
            }}
            hideAddButton={true}
            hideTitle={true}
            isReset={addResetSelected}
            reminder={sourceReminderText}
            error={error.error}
            loadMoreAction={loadMore}
            filterPlaceHolder={filterPlaceHolder}
            isCustomerItem={isCustomerItem}
            filterAction={isSourceReminderLocalFilterable ? null : filter}
            groupKey={groupKey}
            disabled={disabled}
          />
        </div>
        <div
          className={`${
            hasMultiLines
              ? 'custom-add-remove-mutiple-selector-buttons-line-break'
              : 'custom-add-remove-mutiple-selector-buttons'
          }`}
        >
          <div
            className={`d-flex custom-add-remove-mutiple-selector-buttons-area ${
              hasMultiLines ? 'flex-row' : 'flex-column'
            }`}
          >
            <Image
              className="add-remove-botton margin-left-10-percent"
              onClick={() => add()}
              src={sourceSelected?.length ? addOn : addOff}
            />

            <Image
              src={selected?.length ? removeOn : removeOff}
              className="add-remove-botton margin-left-10-percent add-remove-botton-space"
              onClick={() => remove()}
            />
          </div>
        </div>

        <CustomMultipleSelect
          isFilterable={isAmidRreminderLocalFilterable || isAmidRreminderFilterable}
          filterPlaceHolder={filterPlaceHolder}
          isCustomerItem={isCustomerItem}
          subFilterKey={aimdReminderSubfilterKey}
          subFilterItems={aimdReminderSubFilterItems}
          defaultSelected={[]}
          options={amid}
          onSelectChange={(options) => {
            //   setSelectStores(options);
            setRemoveResetSelected(false);
            setSelected(options);

            onFocusFunc();
          }}
          hideAddButton={true}
          isReset={removeResetSelected}
          hideTitle={true}
          reminder={amidReminderText}
          error={error.error}
          groupKey={groupKey}
          disabled={disabled}
        />
      </div>
      {addButton ? (
        <div className="custom-add-remove-mutiple-selector-add-btn-container">
          <AuthButton
            title={addButton.title}
            requires={requires}
            customClass="btn-further add-remove-botton-style"
            action={() => {
              if (addButton.link) {
                history.push(addButton.link);
              }
              if (addButton.action) {
                addButton.action();
              }
            }}
          />
        </div>
      ) : null}
      <ErrorFieldMessage
        id={error.id}
        error={error.error}
        message={error.message}
      />
      {/* {disabled ? (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            // top: 0,
            // left: 0,
            opacity: 0.5,
            background: 'aquamarine',
          }}
        />
      ) : null} */}
    </div>
  );
}

export default withResizeDetector(CustomAddRemoveMutipleSelector);
